import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { groupOptions } from '../../stores/groups/selectors';
import { serverOptions } from '../../stores/servers/selectors';
import { RootState } from '../../stores/store';
import { selectAll, unselectAll } from '../../stores/tables/actionCreators';
import { userOptions } from '../../stores/users/selectors';
import { workspaceOptions } from '../../stores/workspaces/selectors';
import TableColumn from '../table/TableColumn';
import TableFilterableColumn from '../table/TableFilterableColumn';
import TableHead from '../table/TableHead';
import TableSelectionColumn from '../table/TableSelectionColumn';
import TableSortableColumn from '../table/TableSortableColumn';
import {getgroupsId} from '../../repositories/GroupRepository';
import {getSearch,getFilters} from '../../stores/tables/selectors';
import { TableFilters } from '../../stores/tables/state';

interface Props extends LocalizeContextProps {
    refresh: () => void;
    ids: string[];
    filters :TableFilters;
    selectAll: (ids: string[]) => void;
    unselectAll: (ids: string[]) => void;
    search: string;
    userOptions: Array<{ label: string, value: string }>;
    workspaceOptions: Array<{ label: string, value: string }>;
}

class GroupsTableHead extends React.Component<Props> {
    public render() {
        const t = this.props.translate;
        return (
          <TableHead>
            <TableSelectionColumn
              itemIds={this.props.ids}
              tableKey='groups'
              selectAll={() => this.getSelectgroupsId()}
              deselectAll={() => this.getunSelectGroupId()}
            />
            <TableSortableColumn
              tableKey='groups'
              column='name'
              refresh={this.props.refresh}>
              {t('groups.table.header.name')}
            </TableSortableColumn>
            <TableFilterableColumn
              tableKey='groups'
              columnName={t('groups.table.header.users') as string}
              filterKey='u'
              options={this.props.userOptions}
              refresh={this.props.refresh}
            />
            <TableFilterableColumn
              tableKey='groups'
              columnName={t('groups.table.header.workspaces') as string}
              filterKey='w'
              options={this.props.workspaceOptions}
              refresh={this.props.refresh}
            />
            <TableColumn className='icon-btn-th' />
            <TableColumn className='icon-btn-th' />
          </TableHead>
        );
    }

private getSelectgroupsId():  void
{   
    
    getgroupsId(this.props.search,this.props.filters).then
     ( 
      (ids) =>
        this.props.selectAll(ids)   
     );    
    
}
private getunSelectGroupId():  void
{   
  getgroupsId(this.props.search,this.props.filters).then
     (
      (ids) =>
        this.props.unselectAll(ids)   
     );        
}
}
const mapStateToProps = (state: RootState) => ({
    userOptions: userOptions(state),
    workspaceOptions: workspaceOptions(state),
    filters: getFilters(state, 'groups'),
    search: getSearch(state, 'groups'),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  selectAll: (ids: string[]) => dispatch(selectAll('groups', ids)),
  unselectAll: (ids: string[]) => dispatch(unselectAll('groups', ids)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(GroupsTableHead));